export default __webpack_public_path__ + "static/media/640_dummy2016-sprachunterricht01-de.83b6311e.png";